import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../../styles/icons/default.module.scss';

import Wolf1 from '../../../../img/splash/2025/wolf-1.png';
import Wolf2 from '../../../../img/splash/2025/wolf-2.png';
import Wolf3 from '../../../../img/splash/2025/wolf-3.png';
import Wolf4 from '../../../../img/splash/2025/wolf-4.png';
import Wolf5 from '../../../../img/splash/2025/wolf-5.png';

const propTypes = {
    type: PropTypes.number,
    className: PropTypes.string,
};

const defaultProps = {
    type: 1,
    className: null,
};

const MultiWolf = ({ type, className }) => {
    let image = Wolf1;
    switch (type) {
        case 1:
            image = Wolf1;
            break;
        case 2:
            image = Wolf2;
            break;
        case 3:
            image = Wolf3;
            break;
        case 4:
            image = Wolf4;
            break;
        case 5:
            image = Wolf5;
            break;

        default:
            break;
    }
    return (
        <img
            className={classNames([styles.container, { [className]: className !== null }])}
            src={image}
            alt="Wolf"
        />
    );
};

MultiWolf.propTypes = propTypes;
MultiWolf.defaultProps = defaultProps;

export default MultiWolf;
